import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};

  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];

      messages[locale] = locales(key);
    }
  });

  return messages;
}

function getStorage(key) {
  const str = window.localStorage.getItem(key);
  return !str ? "en" : str;
}

const i18n = new VueI18n({
  legacy: false,
  locale: getStorage("Language"),
  fallbackLocale: getStorage("Language"),
  globalInjection: true,
  messages: loadLocaleMessages(),
});

export function $t(args) {
  try {
    return i18n.tc.call(i18n, args);
  } catch (error) {
    return args;
  }
}

export default i18n;
